import { render, staticRenderFns } from "./PostedBills.vue?vue&type=template&id=772cbd57&"
import script from "./PostedBills.vue?vue&type=script&lang=js&"
export * from "./PostedBills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports